// IMPORTS


// COMPONENT
export default function FieldTypes () {
   return (
      <>
         <option value='text'>Text</option>
         <option value='textbox'>Textbox</option>
         <option value='select'>Selectable</option>
         <option value='checkbox'>Checkbox</option>
         <option value='number'>Number</option>
         <option value='code'>Code</option>
         <option value='date'>Date</option>
         <option value='time'>Time</option>
         <option value='datetime'>Date + Time</option>
      </>
   );
}